import { PipeTransform, Pipe } from '@angular/core';

// This pipe returns the index of an element in an array, or -1 if not present
@Pipe({name: 'indexOf'})
export class IndexOfPipe implements PipeTransform {
  transform<T>(arr: Array<T>, element: T): any {
    if (arr === undefined || arr === null) return -1;
    return arr.indexOf(element);
  }
}
